import React from "react";
import { SWRConfig, SWRConfiguration } from "swr";
import { logFrontendError } from "@/observability/frontendErrorLogger";

const getErrorStatus = (error: unknown): number | undefined => {
  const status = (error as { status?: number })?.status;
  return typeof status === "number" ? status : undefined;
};

const swrConfig: SWRConfiguration = {
  dedupingInterval: 2000,
  revalidateOnFocus: false,
  revalidateOnReconnect: false,
  onError: (error, key) => {
    const status = getErrorStatus(error);
    if (status && status < 500) {
      return;
    }
    logFrontendError({
      message: error?.message ?? "SWR request failed",
      severity: "swr",
      stack: error?.stack,
      metadata: { key },
    });
  },
  shouldRetryOnError: (error) => {
    const status = getErrorStatus(error);
    if (typeof status !== "number") {
      return true;
    }
    if (status === 0) {
      return true;
    }
    return status >= 500;
  },
};

export const SwrProvider: React.FC<React.PropsWithChildren> = ({ children }) => (
  <SWRConfig value={swrConfig}>{children}</SWRConfig>
);
